// composables/useAppStatApi.ts
import {getApiConstants} from '~/utils/constants'

export const useSummaryStats = () => {
  return {
    async getSummaryStats() {
      try {
        const api = getApiConstants()
        const http = useHttp()

        return await http.get(`${api.SUMMARY}getstats`)
      } catch (e) {
        return e
      }
    },
  }
}

export const useSummaryData = () => {
  return {
    async getSummaryData(forceRefresh = false) {
      try {
        const api = getApiConstants()
        const http = useHttp()
        return await http.get(`${api.SUMMARY}getdata`, forceRefresh)
      } catch (e) {
        return e
      }
    }
  }
}

